// https://switcheroo.atlassian.com/ui/gates/8078ffd6-b819-4b3c-b50c-438ed54e1f70/key/rovo_jira_twg_cli_cta_v2
// Experiment gate - controls which cohort the user is in for the experiment
export const ROVO_JIRA_TWG_CLI_CTA_EXPERIMENT = 'rovo_jira_twg_cli_cta_v2';

export const ROVO_JIRA_TWG_CLI_CTA_TREATMENT_PARAM = 'rovo_jira_twg_cli_cta_treatment';

export type RovoJiraTwgCliCtaCohort = 'control' | 'treatment';

export const RovoJiraTwgCliCtaCohort = { CONTROL: 'control', TREATMENT: 'treatment' } as const;
